.notification-banner {
  background-color: var(--blue-200);
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 16px;
  padding-left: 8px;
  display: flex;
  justify-content: space-between;
  font-size: 0.875rem;
  line-height: 0.5;
  color: var(--neutral-600);
}

.notification-banner-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.notification-banner-info .icon {
  color: var(--blue-600);
}

.notification-banner-actions {
  display: flex;
  align-items: center;
}

.notification-banner-button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: var(--blue-600);
  font-size: 0.875rem;
  display: flex;
  align-items: center;
}

.notification-banner-button:hover {
  color: var(--blue-800);
}